import { Controller } from "@hotwired/stimulus"

// Similar-curator heads-up on the curator forms (owner directive
// 2026-09-12, after a census found pairs like "Allo.B" / "Allo B" and two
// "Redlist" rows splitting one person's history). Before the form saves,
// ask the server whether the typed name or a contact handle already belongs
// to another curator, and show who and why. A heads-up, never a block: the
// operator can save anyway. Rides window.appConfirm, the ONE app modal.
//
// The server asks the same question again (curators#create/update) for a
// submit that arrives unconfirmed; when it has already answered with the
// inline panel (the panel target is present), this controller stays out
// of the way and the panel's checkbox carries the answer.
export default class extends Controller {
  static values = { url: String, excludeId: String }
  static targets = ["name", "contact1", "contact2", "paypal", "confirm", "panel"]

  async check(event) {
    if (this.confirmed || this.hasPanelTarget) return
    const form = event.target
    event.preventDefault()

    let matches = []
    try {
      const query = new URLSearchParams({
        name: this.field("name"),
        contact_value: this.field("contact1"),
        contact_value_2: this.field("contact2"),
        paypal_email: this.field("paypal"),
        exclude_id: this.excludeIdValue || ""
      })
      const res = await fetch(`${this.urlValue}?${query}`, { headers: { Accept: "application/json" } })
      matches = (await res.json()).matches || []
    } catch (e) {
      // A lookup failure must never block a legitimate save; the server
      // guard still asks.
    }

    if (matches.length) {
      const ok = await window.appConfirm(
        "Review the match before saving. If this is the same person, go back and update their record instead of creating a second one.",
        {
          title: "This looks a lot like a curator already on file",
          items: matches.map((m) => ({
            initials: this.initials(m.name),
            name: m.name,
            detail: `${m.status}, ${m.placements} placement${m.placements === 1 ? "" : "s"}, $${Number(m.spent).toLocaleString()} spent. ${this.capitalize(m.reason)}.`
          })),
          confirmLabel: "Save anyway",
          cancelLabel: "Go back",
          focus: "cancel"
        }
      )
      if (!ok) return
      if (this.hasConfirmTarget) this.confirmTarget.value = "1"
    }

    this.confirmed = true
    form.requestSubmit()
  }

  field(name) {
    const el = this.targets.find(name)
    return el ? el.value.trim() : ""
  }

  initials(name) {
    return String(name || "").split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0].toUpperCase()).join("") || "?"
  }

  capitalize(text) {
    const s = String(text || "")
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
}
